/*
 * @Author: lidan
 * @Date: 2020-11-12 09:27:07
 * @LastEditTime: 2020-11-19 15:00:23
 * @LastEditors: lidan
 * @Description: 运单应收费用api
 * @FilePath: \e6-module-settle-accounts-center\src\e6-module-settle-accounts-center\api\waybillReceivable.js
 */
import http from "e6-base-core/axios/config";
import { e6ModuleSettleAccountsCenterApi } from "@/config/api";
const {
  host = "",
  E6_MS_TMS_FINANCIAL_WEB = ""
} = e6ModuleSettleAccountsCenterApi;

// 获取运单应收费用表格数据
export function waybillReportReceivable(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/waybillReport/income`,
    method: "post",
    data
  });
}

// 导出运单应收费用
export function exportWaybillReceivable(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/waybillReport/export/income`,
    method: "post",
    data
  });
}
